import './create.css';

import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Group from 'src/entities/Group';
import Member from 'src/entities/Member';
import Wiki from 'src/entities/Wiki';

import { createWiki } from '../../actions/wiki';
import Navigation from '../Navigation/global';
import NavigationMember from '../Navigation/member';
import SwitchAdmin from '../Navigation/switchAdmin';

interface IProps {
  account: Member;
  groupTitle: string;
  group: Group;
  createWiki: (wiki: Wiki) => void;
}

interface IState {
  wiki: Wiki;
  isCreated: boolean;
}

class CreateComponent extends React.Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = {
      wiki: new Wiki(),
      isCreated: false
    };

    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.createWiki = this.createWiki.bind(this);
  }

  render() {
    if (this.props.group === undefined || this.state.isCreated) {
      return (
        <Redirect
          to={{
            pathname: '/' + this.props.groupTitle + '/wikis'
          }}
        />
      );
    }

    return (
      <div id="WikiCreate">
        <Navigation group={this.props.group.title} />

        <div id="NavigationFunction">
          <NavigationMember function="wiki" group={this.props.group} />

          {this.props.account.isSystemAdmin ||
          this.props.group.admins.includes(this.props.account.id) ? (
            <SwitchAdmin group={this.props.group} />
          ) : null}
        </div>

        <div id="Title">
          <input
            className="InputText"
            value={this.state.wiki.title}
            onChange={this.onChangeTitle}
            placeholder="記事のタイトル"
          />
        </div>
        <textarea
          id="Text"
          onChange={this.onChangeText}
          placeholder="記事の本文"
        >
          {this.state.wiki.text}
        </textarea>
        <div id="Actions">
          <button onMouseUp={this.createWiki} onTouchEnd={this.createWiki}>
            作成する
          </button>
        </div>
      </div>
    );
  }

  onChangeTitle(e: any) {
    const wiki = Object.assign({}, this.state.wiki);
    wiki.title = e.target.value;

    this.setState({
      wiki
    });
  }

  onChangeText(e: any) {
    const wiki = Object.assign({}, this.state.wiki);
    wiki.text = e.target.value;

    this.setState({
      wiki
    });
  }

  createWiki() {
    if (this.state.wiki.title.length > 0 && this.state.wiki.text.length > 0) {
      const wiki = Object.assign({}, this.state.wiki);
      wiki.groupId = this.props.group.id;
      wiki.created = Date.now();
      this.props.createWiki(wiki);
      this.setState({
        isCreated: true
      });
    }
  }
}

const mapStateToProps = (state: any, ownProps: any) => ({
  groupTitle: ownProps.match.params.group,
  account: state.Account,
  group: state.Group.find(
    (group: Group) => group.title === ownProps.match.params.group
  )
});

const mapDispatchToProps = (dispatch: any) => {
  return {
    createWiki(wiki: Wiki) {
      dispatch(createWiki(wiki));
    }
  };
};

const Create = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateComponent);

export default Create;



// WEBPACK FOOTER //
// ./src/components/Wiki/create.tsx